/*
 * <syrup-formula-linked>  —  "Ohora Formula (Product Linked)" section
 *
 * ohora-formula-2 icindeki SyrupFormula davranisinin BAGIMSIZ kopyasi.
 * Fark: secilen swatch'in ana gorseli ayni zamanda tiklanabilir bir urun
 * linkine (data-product-url) donusur; gorsel uzerindeki "Urune Git" CTA'si
 * link varken gorunur, yokken gizlenir.
 *
 * Cekirdek assets/custom.js DEGISTIRILMEZ; bu dosya ayri bir custom element
 * tanimlar ve tema editorunun section yeniden render etmesiyle uyumludur.
 */
(function () {
  'use strict';

  if (customElements.get('syrup-formula-linked')) return;

  class SyrupFormulaLinked extends HTMLElement {
    constructor() {
      super();
      this.handleSwatchClick = this.handleSwatchClick.bind(this);
    }

    connectedCallback() {
      this.mainImageEl = this.querySelector('[data-role="main-image"]');
      this.mainLinkEl = this.querySelector('[data-role="main-link"]');
      this.swatchEls = Array.from(this.querySelectorAll('[data-role="syrup-swatch"]'));
      if (!this.mainImageEl || !this.swatchEls.length) return;

      this.swatchEls.forEach((btn) => {
        btn.addEventListener('click', this.handleSwatchClick);
      });

      const defaultGroup = this.dataset.defaultGroup || 'water';
      const groupSwatches = this.swatchEls.filter((btn) => btn.dataset.group === defaultGroup);
      const initialSwatch = groupSwatches[0] || this.swatchEls[0];
      this.setActiveSwatch(initialSwatch);
    }

    disconnectedCallback() {
      if (!this.swatchEls) return;
      this.swatchEls.forEach((btn) => {
        btn.removeEventListener('click', this.handleSwatchClick);
      });
    }

    handleSwatchClick(event) {
      this.setActiveSwatch(event.currentTarget);
    }

    setActiveSwatch(btn) {
      if (!btn) return;

      this.swatchEls.forEach((el) => {
        el.classList.toggle('is-active', el === btn);
      });

      const imgSrc = btn.dataset.mainImage;
      const imgAlt = btn.dataset.mainAlt || '';
      const productUrl = btn.dataset.productUrl || '';

      if (imgSrc) this.mainImageEl.src = imgSrc;
      this.mainImageEl.alt = imgAlt;
      this.dataset.activeGroup = btn.dataset.group;

      if (this.mainLinkEl) {
        if (productUrl) {
          this.mainLinkEl.setAttribute('href', productUrl);
          this.mainLinkEl.classList.add('is-linked');
        } else {
          this.mainLinkEl.removeAttribute('href');
          this.mainLinkEl.classList.remove('is-linked');
        }
      }
    }
  }

  customElements.define('syrup-formula-linked', SyrupFormulaLinked);
})();
